export async function debridAlldebrid(apiToken: string, link: string) {
  const endpoint = 'https://api.alldebrid.com/v4/';
  const result = await fetch(
    `${endpoint}link/unlock?agent=webapp_v4&apikey=${apiToken}&link=${link}`,
  ).then(r => r.json());

  if (result.error) {
    return {error: result.error.message, success: false};
  }
  if (result.status === 'success') {
    return {link: result.data.link, success: true};
  } else {
    return {error: result.error.message, success: false};
  }
}

export async function debridLinks(apiToken: string, link: string) {
  const debridResult = await debridAlldebrid(apiToken, link);
  if (debridResult.success && debridResult.link) {
    return {link: debridResult.link, success: true};
  } else {
    return {error: debridResult.error, success: false};
  }
}

function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
